import type { FlowLayoutNode } from '@lighthouse/shared'
import mitt from 'mitt'

type Coordinate = {
    x: number
    y: number
}

export type FlowLayoutEvents = {
    beginAdding: MouseEvent
}

export const flowLayoutEmitter = mitt<FlowLayoutEvents>()

export const flowLayoutBeginAdding = (payload: FlowLayoutEvents['beginAdding']) => {
    flowLayoutEmitter.emit('beginAdding', payload)
}
